module.exports = __webpack_public_path__ + "static/ms-exp-e008c83cc0c5ed38e26dc797a82c378c.svg";